// extracted by mini-css-extract-plugin
export var jointContent = "index-module--jointContent--4DHD2";
export var more = "index-module--more--Ln-W4";
export var regionHeader = "index-module--regionHeader--yZ6nw";